Vue.component('search-terms-online', {
  props: ['skrot', 'room', 'alimentation', 'start_date', 'end_date', 'adults', 'children', 'age_child_1', 'age_child_2', 'age_child_3', 'age_child_4', 'info', 'extraparameters', 'btnClass'],
  template: '#vue-search-terms-online',
  data: function () {
    return {
      elementHandle: 'terms_' + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15),
      termsLoaded: false,
    }
  },
  created: function () {
    console.log('search-terms-online');
  },
  methods: {
    showTermsTable: function (el) {
      this.termsLoaded = true;
      colorboxInlineHTML($(el));

      const self = this;
      $(document.body).one("click", '#cboxClose', function () {
        self.termsLoaded = false;
      });
    }
  }
});

Vue.component('search-terms-online-table', {
  props: ['skrot', 'room', 'alimentation', 'start_date', 'end_date', 'adults', 'children', 'age_child_1', 'age_child_2', 'age_child_3', 'age_child_4', 'info', 'extraparameters'],
  template: '#vue-search-terms-online-table',
  data: function () {
    return {
      agent: '',
      touroperator: '',
      mw: 'default',
      mwOptions: [],
      day: 'default',
      days: [],
      month: '',
      year: '',
      tabs: [],
      activeTab: '',
      terms: [],
      loaded: false,
      pageSize: 12,
      pageNumber: 0,
      show: {
        mw: false,
        day: false
      },
    }
  },
  created: function () {
    let dataChanged = false;

    if (typeof this['extraparameters'] !== 'undefined') {
      // if (typeof this['extraparameters']['day'] !== 'undefined') {
      //     this.day = this['extraparameters']['day'];
      //     dataChanged = true;
      // }
      if (typeof this['extraparameters']['mw'] !== 'undefined') {
        this.mw = this['extraparameters']['mw'];
        dataChanged = true;
      }
    }

    if (this.day === '' || this.day == 'default') {
      if (this.start_date && this.end_date) {
        let a = moment(this.end_date, 'DD.MM.YYYY', true);
        let b = moment(this.start_date, 'DD.MM.YYYY', true);
        this.day = a.diff(b, 'days');
      } else {
        this.day = '2';
      }
      dataChanged = true;
    }
    if (!dataChanged) {
      this.getTerms(this.skrot, this.room, this.alimentation, this.adults, this.children, this.age_child_1, this.age_child_2, this.age_child_3, this.age_child_4, this.day, this.month, this.year, this.mw);
    }
  },
  watch: {
    skrot: function (newSkrot, oldSkrot) {
      if (newSkrot != oldSkrot) {
        this.getTerms(this.skrot, this.room, this.alimentation, this.adults, this.children, this.age_child_1, this.age_child_2, this.age_child_3, this.age_child_4, this.day, this.month, this.year, this.mw);
      }
    },
    mw: function (newMw, oldMw) {
      if (newMw != oldMw) {
        // TO DO: odswiezanie z MW
        this.getTerms(this.skrot, this.room, this.alimentation, this.adults, this.children, this.age_child_1, this.age_child_2, this.age_child_3, this.age_child_4, this.day, this.month, this.year, newMw);
      }
    },
    alimentation: function (newAlimentation, oldAlimentation) {
      if (newAlimentation != oldAlimentation) {
        // this.getTerms(this.skrot, this.room, newAlimentation, this.adults, this.children, this.age_child_1, this.age_child_2, this.age_child_3, this.age_child_4, this.day, this.month, this.year, this.mw);
      }
    },
    day: function (newDay, oldDay) {
      if (newDay != oldDay) {
        this.getTerms(this.skrot, this.room, this.alimentation, this.adults, this.children, this.age_child_1, this.age_child_2, this.age_child_3, this.age_child_4, newDay, this.month, this.year, this.mw);
      }
    },
    pageNumber: function (newPageNumber, oldPageNumber) {
      if (newPageNumber != oldPageNumber) {
        if ($(".search-details-terms #tabs").length) {
          if (!$(".search-details-terms #tabs").parents('#colorbox').length) {
            // const $element = $(".search-details-terms #tabs");
            // window.scrollTo(0, $element.offset().top);
            const element = document.getElementById("tabs");
            window.scrollTo(0, element.offsetTop);
          }
        }
      }
    }
  },
  methods: {
    getTerms: function (skrot, room, alimentation, adults, children, age_child_1, age_child_2, age_child_3, age_child_4, day, month, year, mw) {
      const self = this;
      self.loaded = false;
      $.post("/back/search/SearchTerms.php", { skrot: skrot, room: room, alimentation: alimentation, adults: adults, children: children, age_child_1: age_child_1, age_child_2: age_child_2, age_child_3: age_child_3, age_child_4: age_child_4, day: day, month: month, year: year, mw: mw }, function (result, textStatus) {
        let waitForNextAjax = false; // Czasem jest wysylane kilka AJAXow gdy byly wybrakowane parametry

        self.pageNumber = 0;
        self.agent = result.config.agent;
        self.touroperator = result.config.touroperator;
        self.show.mw = result.config.show.mw;
        if (typeof result.config.show.day !== 'undefined') self.show.day = result.config.show.day;
        self.mwOptions = result.mw;
        self.tabs = result.tabs;
        if (self.activeTab == '' && typeof self.tabs[0] !== 'undefined' && typeof self.tabs[0].label !== 'undefined') {
          self.activeTab = self.tabs[0].label;
        }
        self.terms = result.terms;
        self.days = result.days;

        let dayTMP = self.day;
        if ((dayTMP === '' || dayTMP == 'default') && self.start_date && self.end_date) {
          const a = moment(self.end_date, 'DD.MM.YYYY', true);
          const b = moment(self.start_date, 'DD.MM.YYYY', true);
          dayTMP = a.diff(b, 'days');
        }

        let przedzalyDni = false;
        for (let i = 0; i < self.days.length; i++) {
          if (self.days[i].toString().indexOf('-') > -1) {
            if (!przedzalyDni) przedzalyDni = true;
            let days = self.days[i].split("-");
            if (days[0] == days[1]) self.days[i] = days[0];
          }
        }

        if (self.days.length && typeof self.days[0] !== 'undefined' && przedzalyDni && dayTMP.toString().indexOf('-') <= -1) {
          let dayFound = false;
          if (dayTMP === '' || dayTMP == 'default') {
            dayTMP = self.days[Math.floor(self.days.length / 2)];
          } else {
            for (let i = 0; i < self.days.length; i++) {
              if (self.days[i].toString().indexOf('-') > -1) {
                let days = self.days[i].split("-");

                if (dayTMP >= days[0] && day <= days[1]) {
                  dayTMP = self.days[i];
                  dayFound = true;
                  break;
                }
              } else {
                if (dayTMP == self.days[i]) {
                  dayFound = true;
                  break;
                }
              }
            }
            if (!dayFound) {
              dayTMP = self.days[Math.floor(self.days.length / 2)];
            }
          }
        }

        if (self.day !== dayTMP) {
          self.day = dayTMP;
          waitForNextAjax = true; // Bedzie odswiezane
        }

        if (!waitForNextAjax) self.loaded = true;
      }, "json");
    },
    changeDataInTab: function (tab) {
      this.month = tab.month;
      this.year = tab.year;
      this.getTerms(this.skrot, this.room, this.alimentation, this.adults, this.children, this.age_child_1, this.age_child_2, this.age_child_3, this.age_child_4, this.day, this.month, this.year, this.mw);
      this.setPage(0);
      this.activeTab = tab.label;
    },
    getPage: function () {
      return this.pageNumber;
    },
    setPage: function (pageNumber) {
      this.pageNumber = pageNumber;
    },
    nextPage: function () {
      if (this.pageNumber < this.pageCount() - 1) {
        this.pageNumber++;
      }
    },
    prevPage: function () {
      if (this.pageNumber > 0) {
        this.pageNumber--;
      }
    },
    pageCount: function () {
      return Math.floor(this.terms.length / this.pageSize) + 1;
    },
    paginatedIndex: function () {
      let index = [];
      for (let i = 0, len = this.pageCount(); i < len; i++) {
        index[i] = i + 1;
      }
      return index;
    },
    paginatedData: function () {
      const start = this.pageNumber * this.pageSize;
      const end = start + this.pageSize;
      return this.terms.slice(start, end);
    },
    getPopUpLink: function (term) {
      const self = this;
      let skrot = encodeURIComponent(term.skrot);
      let roomtype = encodeURIComponent(self.room.replaceAll("|", "/"));

      let href = "//wwwgen.sykon.pl/afiliacjaariadna1B/agx/" + this.agent + "/index.php?szukaj=szukaj_wycieczki&adults=" + this.adults + "&top=" + this.touroperator + "&rewrite=on&tourop=agx&agentx=" + this.agent + "&onepage=20&from=" + term.departureDateYmd + "&to=" + term.arrivalDateYmd + "&tourop_hotel=" + this.touroperator + "|" + skrot + "&roomtype=" + roomtype + "&md=get_md_value";
      if (typeof term.arrivalPlace !== 'undefined' && typeof term.departurePlace !== 'undefined' && term.departurePlace !== '' && term.departurePlace !== 'default') {
        href += "&busstop=" + term.departurePlace + "-" + term.arrivalPlace;
      }

      return href;
    }
  }
});